import React, { Suspense } from 'react';
import ReactDOM from 'react-dom';
import App from './App';
import Loading from './components/Layout/Loading/Loading';
import 'semantic-ui-css/semantic.min.css';

ReactDOM.render(
  <Suspense fallback={<Loading />}>
    <App />
  </Suspense>,
  document.getElementById('root')
);
